import React, {
    useState,
    forwardRef,
    useRef,
    useEffect,
    useImperativeHandle,
  } from "react"
import IntersectionVisible from 'components/IntersectionVisible'

import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Card from 'components/index/Card'
import FacebookCommentsSection from "components/FacebookCommentsSection"

import { getFeaturedBreaks, getPointsForBreak } from 'services/break'

import "./CompleteStep3.scss"

/*

*/
const SliderComponent = forwardRef((props, ref) => {

    var sliderRef = {}
    var settings = {
      dots: true,
      arrows: true,
      infinite: false,
      speed: 500,
      variableWidth: true,
      dotsClass: "slick-dots card__slider-dots",
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    }
  
    useImperativeHandle(ref, () => ({
      GotoSlick() {
        sliderRef.slickGoTo(0)
      },
    }))
  
    return (
      props.children ? 
        <Slider
          className={"card__slider"}
          ref={slider => (sliderRef = slider)}
          {...settings}
        >
          {props.children.map((obj, index) => {
            return <React.Fragment key={index}>{obj}</React.Fragment>
          })}
        </Slider>
      :
        <></>
    )
  })


const usePrevious = (value, initialValue) => {
  const ref = useRef(initialValue);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

const useEffectDebugger = (effectHook, dependencies, dependencyNames = []) => {
  const previousDeps = usePrevious(dependencies, []);

  const changedDeps = dependencies.reduce((accum, dependency, index) => {
    if (dependency !== previousDeps[index]) {
      const keyName = dependencyNames[index] || index;
      return {
        ...accum,
        [keyName]: {
          before: previousDeps[index],
          after: dependency
        }
      };
    }

    return accum;
  }, {});

  if (Object.keys(changedDeps).length) {
    console.log('[use-effect-debugger] ', changedDeps);
  }

  useEffect(effectHook, dependencies);
};

const CompleteStep3 = ({ brk, isEmbed, breakId, step, onEngage = function() {}, onAwardPoints = function() {}, userType, service }) => {

    const [awardedPoints, setAwardedPoints] = useState(0)
    const [featuredBreaks, setFeaturedBreaks] = useState([])
    const childRef = useRef()

    const handleIsOnScreen = async (isIntersecting) => {
        if (isIntersecting) {
          onEngage()
			    await onAwardPoints()

          const awardedPts = await getPointsForBreak(breakId)
          setAwardedPoints(awardedPts.detail)
        }
    }

    // onload, get points so far -- will not include the points they get for visiting this step the first time
    useEffect(() => {

      const asyncWrapper = async () => {
        try {
            const response = await getPointsForBreak()
            setFeaturedBreaks(response.detail) 
        } catch (e) {

        }
      }
      asyncWrapper()

    }, [setAwardedPoints, getPointsForBreak])

    // useEffectDebugger(() => {
    useEffect(() => {
        const asyncWrapper = async () => {
          try {
              const response = await getFeaturedBreaks({limit: 7})
              setFeaturedBreaks(response.detail) 
          } catch (e) {
              // a 401 can get thrown for guests
              // console.log(e)
          }
        }

        if (!isEmbed) {
          asyncWrapper()
        }        
    }, [isEmbed, getFeaturedBreaks, setFeaturedBreaks])


    return (
		<section className={`complete-step`}>
			<div className={`step-content step-content-100`}>
				<IntersectionVisible active={true} options={{
									threshold: 0.4,
								}} onIntersect={handleIsOnScreen}>
					
                        <div className="container">
                            <div className="content">
                                <h2 className="complete-title">Congrats you did it!{!isEmbed ? ` You earned ${awardedPoints} points.` : ''} </h2>
                                {step && step.headline &&
                                    <p dangerouslySetInnerHTML={{__html: step.headline}}></p>
                                }
                            </div>

                            <div className="card__slider">
                            <SliderComponent className="card__slider" ref={childRef}>
                                {featuredBreaks && featuredBreaks.map((brk, index) => {
                                    return (
                                        <Card brk={brk} key={index} thumbnail={false}></Card>
                                    )
                                })}
                            </SliderComponent>
                            </div>
                        </div>
                        
                        { brk.facebookEnabled && 
                          <FacebookCommentsSection question={step.commentQuestion || ""} editorial={false}/>
                        }
                    
				</IntersectionVisible>
			</div>
		</section>

    )

}

export default CompleteStep3